import LinkToRecord from './link-to-record';

export default LinkToRecord;
